var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckGreenIcon = function SvgCheckGreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.34091,
    fill: "#286D2F",
    stroke: "#286D2F",
    strokeWidth: 2.31818
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1577 5.96823C12.2231 6.03352 12.275 6.11109 12.3104 6.19649C12.3458 6.28188 12.364 6.37343 12.364 6.46589C12.364 6.55835 12.3458 6.6499 12.3104 6.7353C12.275 6.82069 12.2231 6.89826 12.1577 6.96356L7.94396 11.181C7.87872 11.2465 7.80123 11.2984 7.71591 11.3339C7.63058 11.3693 7.53912 11.3876 7.44674 11.3876C7.35437 11.3876 7.2629 11.3693 7.17758 11.3339C7.09226 11.2984 7.01476 11.2465 6.94953 11.181L4.84267 9.0723C4.7108 8.94031 4.63672 8.7613 4.63672 8.57464C4.63672 8.38798 4.7108 8.20896 4.84267 8.07697C4.97454 7.94498 5.1534 7.87083 5.33989 7.87083C5.52638 7.87083 5.70524 7.94498 5.83711 8.07697L7.44674 9.68946L11.1632 5.96823C11.2285 5.90277 11.306 5.85083 11.3913 5.81539C11.4766 5.77996 11.5681 5.76172 11.6604 5.76172C11.7528 5.76172 11.8443 5.77996 11.9296 5.81539C12.0149 5.85083 12.0924 5.90277 12.1577 5.96823Z",
    fill: "white"
  })));
};
export default SvgCheckGreenIcon;